export default __webpack_public_path__ + "static/arezoo_image-ec67c0d98313b69beedf6fdb30a8fcfb.jpeg";